module.exports = __webpack_public_path__ + "img/logo-small.cb3fe4a6.svg";